import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=08c5b3c4&scoped=true&"
import script from "./Lessons.vue?vue&type=script&lang=js&"
export * from "./Lessons.vue?vue&type=script&lang=js&"
import style0 from "./Lessons.vue?vue&type=style&index=0&id=08c5b3c4&lang=scss&scoped=true&"
import style1 from "./Lessons.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c5b3c4",
  null
  
)

export default component.exports